export default __webpack_public_path__ + "static/5-ab82005a7ac9cce0a851ca7570124adc.jpg";